export function getMainStatus() {
    return [
        { value: "Emails", label: "Emails", color: '#3467FF' }
    ]
}
